import { Component, Input } from '@angular/core';
import { StatesService } from 'src/app/services/states.service';

@Component({
  selector: 'app-text-component',
  templateUrl: './text-component.component.html',
  styleUrls: ['./text-component.component.scss'],
})
export class TextComponentComponent {
  @Input() component: any;
  @Input() htmlString: any;
  viewInit = false;

  constructor(public statesService: StatesService) {}
  
  ngOnInit(): void {}

  ngOnChanges(changes: any) {
    if (
      this.htmlString &&
      this.component.content &&
      this.htmlString !== this.component.content
    ) {
      setTimeout(() => {
        this.doAutoHeight(this.component);
      }, 10);
    }
  }

  doAutoHeight(selectedComponent: any) {
    if (selectedComponent.autoHeight == true) {
      selectedComponent.height = 0;
      let componentElem = document.getElementById(
        'component-ys-inner-' + selectedComponent.id
      );

      // check for padding notation...
      let paddingOffset = 0;
      if (String(selectedComponent.style.padding).indexOf(' ') >= 0) {
        let paddingSplit = selectedComponent.style.padding.split(' ');
        if (paddingSplit[0] && paddingSplit[2]) {
          paddingOffset = +paddingSplit[0] + +paddingSplit[2];
        }
      } else {
        paddingOffset = selectedComponent.style.padding * 2;
      }

      if (componentElem) {/*
        let children = componentElem.children;
        let qlEditorElem: any = children[0];
        qlEditorElem.style.height = 0;
        selectedComponent.height = qlEditorElem.scrollHeight + paddingOffset;
        qlEditorElem.style.height = '100%';*/
        selectedComponent.height = componentElem.scrollHeight + paddingOffset;
      }
    }
  }

  onFocus() {
    this.statesService.onFocus(this.component);
  }
  onBlur() {
    this.statesService.onBlur(this.component);
  }
  onMouseDown() {
    this.statesService.onMouseDown(this.component);
  }
  onMouseUp() {
    this.statesService.onMouseUp(this.component);
  }

  onMouseEnter() {
    this.statesService.onMouseEnter(this.component);
  }
  onMouseLeave() {
    this.statesService.onMouseLeave(this.component);
  }
}
